import { View } from 'react-native';
import Text from 'design-system/Text';
import { CardView, ProgressBar, rem } from 'design-system';
import React, { memo } from 'react';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
import { StepCard } from './StepCard';
import { useCompleteSetupSteps } from './useCompleteSetupSteps';
export const CompleteSetup = memo(({ onLayout, cardStyle, Section }) => {
    const styles = useStyles(styleSet);
    const colors = useColors();
    const { availableCount, completedCount, stepsToComplete, onStepPress } = useCompleteSetupSteps();
    if (availableCount === completedCount) {
        return null;
    }
    return (<Section title="Complete setup" style={cardStyle} button={<View style={styles.titleContainer}>
            <ProgressBar style={styles.progress} barBackgroundColor={colors.background.brandLight} position={(completedCount / availableCount) * 100} colors={colors.gradients.ultimate.colors}/>
            <Text Text-16>{`${completedCount}/${availableCount}`}</Text>
          </View>} onLayout={onLayout}>
        <CardView noMarginTop noMarginBottom style={styles.card}>
          {stepsToComplete.map((step) => (<StepCard key={step.id} step={step} onStepPress={onStepPress}/>))}
        </CardView>
      </Section>);
});
const styleSet = createStyleSheets((colors) => ({
    card: {
        marginHorizontal: rem(16),
    },
    titleContainer: {
        flexShrink: 1,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: 'flex-end',
    },
    progress: {
        width: rem(113),
        backgroundColor: colors.background.brandLight,
        marginHorizontal: rem(14),
    },
}));
